import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IProfileChangesState {
  editProfile: {
    isLoading: boolean;
    errors: IFormErrors | null;
    success: boolean;
  };
  editAvatar: {
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialProfileChangesState: IProfileChangesState = {
  editProfile: {
    isLoading: false,
    errors: null,
    success: false,
  },
  editAvatar: {
    isLoading: false,
    errors: null,
  },
};
